<div class="chat-empty-container">
  <messaging-avatar
    [name]="$safeNavigationMigration(profileInfo()?.subjectMessageableEntity?.displayName)"
    [src]="$safeNavigationMigration(profileInfo()?.subjectMessageableEntity?.profileImageURL)"
    [initialsSize]="2"
    size="70"
    [ngStyle]="{ cursor: profileInfo()?.subjectMessageableEntity?.profileImageURL ? 'pointer' : 'default' }"
    (click)="
      imagesService.openPhoto(
        $safeNavigationMigration(profileInfo()?.subjectMessageableEntity?.profileImageURL) ?? '',
        undefined,
        false
      )
    ">
  </messaging-avatar>
  <h1 class="chat-empty-container__title">{{ 'NGX-MESSAGING.CHAT.welcome' | translate }}</h1>
  <p class="chat-empty-container__subtitle">
    {{ 'NGX-MESSAGING.CHAT.noConversationHasBeenStarted' | translate }}
  </p>
  @if ( !selectedChannel()?.isMember && (selectedChannel()?.type === ChannelType.SUPPORT || selectedChannel()?.type ===
  ChannelType.GROUP) && !selectedChannel()?.isPrivate ) {
  <ngx-join-channel></ngx-join-channel>
  }
</div>
